import React, {Fragment, useState} from 'react';
import {Modal, ModalBody, ModalHeader} from '../modal/Modal';
import Tooltip from "../tooltip/Tooltip";
import "./DisplayUrlContent.scss";

const DisplayUrlContent = (props) => {
    const { open, url, onToggleModal, headerTitle } = props;
    const [modalFullScreen, setModalFullScreen] = useState(false);
    const [loading, setLoading] = useState(true);

    const onClickTermsOfServiceModalScreenToggle = (e) => {
        e.preventDefault();
        setModalFullScreen(!modalFullScreen);
    };

    const getFullScreenModalStyle = () => {
        if (modalFullScreen) {
            return 'modal-full-screen'
        }
    };

    return (
        <Modal isOpen={open} className={`modal-lg ${getFullScreenModalStyle()}`}>
            <ModalHeader toggle={onToggleModal}>
                <div className="modal-title">
                    {`${headerTitle ? headerTitle : 'Terms of services'}`}
                    {modalFullScreen && (
                        <Fragment>
                            <a rel="noopener noreferrer" href={"!#"}
                               className="btn btn-sm float-right"
                               onClick={(e) => onClickTermsOfServiceModalScreenToggle(e)}
                               id="btnMinimize">
                                <span>
                                    <i className={modalFullScreen ? "fa fa-compress" : "fa fa-expand"}> </i>
                                </span>
                            </a>
                            <Tooltip
                                placement="bottom"
                                target="btnMinimize">
                                MINIMIZE SCREEN
                            </Tooltip>
                        </Fragment>
                    )}
                    {!modalFullScreen && (
                        <Fragment>
                            <a rel="noopener noreferrer" href={"!#"}
                               className="btn btn-sm float-right"
                               onClick={(e) => onClickTermsOfServiceModalScreenToggle(e)}
                               id="btnMaximize">
                                <span>
                                    <i className={modalFullScreen ? "fa fa-compress" : "fa fa-expand"}> </i>
                                </span>
                            </a>
                            <Tooltip
                                placement="bottom"
                                target="btnMaximize">
                                FULL SCREEN
                            </Tooltip>
                        </Fragment>
                    )}
                </div>
            </ModalHeader>
            <ModalBody>
                {loading && <div>Loading...</div>}
                <iframe
                    className="embed-responsive-item" title="Terms of service"
                    onLoad={() => setLoading(false)}
                    src={url}
                />
            </ModalBody>
        </Modal>
    );
};

export default DisplayUrlContent;
